import React from 'react';
import styled from 'styled-components';
import MaterialToggleButtonGroup, { ToggleButtonGroupProps } from '@mui/material/ToggleButtonGroup';
import Collapse from '@mui/material/Collapse';
import { AlertIcon } from '@buoyhealth/common.buoy-icons';
import ToggleButton, { IToggleButtonProps } from './ToggleButton';

interface IOption extends IToggleButtonProps {
  label: string;
  subText?: string;
  token?: string;
  media?: string;
  mediaAltText?: string;
}

export interface IToggleButtonGroupProps extends ToggleButtonGroupProps {
  errorMessage?: string;
  multiSelect?: boolean;
  hasError?: boolean;
  options: IOption[];
}

const ErrorContainer = styled.div`
  ${(props) => props.theme.typography.variants.primary.small};
  color: ${(props) => props.theme.palette.status.error};
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    margin-right: 8px;
  }
`;

/** Used to group related toggle buttons in forms */
export default function ToggleButtonGroup({
  errorMessage,
  hasError,
  onChange,
  options,
  multiSelect,
  value,
  ...rest
}: IToggleButtonGroupProps) {
  return (
    <>
      <Collapse in={hasError && !!errorMessage}>
        <ErrorContainer>
          <AlertIcon size={14} />
          {errorMessage}
        </ErrorContainer>
      </Collapse>
      <MaterialToggleButtonGroup
        exclusive={!multiSelect}
        fullWidth
        onChange={onChange}
        orientation="vertical"
        role={!multiSelect ? 'radiogroup' : 'group'}
        value={value}
        {...rest}
      >
        {options.map((option) => (
          <ToggleButton
            key={`${option.label}-${option.value}`}
            hasError={hasError}
            multiSelect={multiSelect}
            role={!multiSelect ? 'radio' : 'checkbox'}
            selected={value?.includes?.(option.value) || value === option.value}
            subText={option.subText}
            {...option}
          />
        ))}
      </MaterialToggleButtonGroup>
    </>
  );
}
